import chalk from "chalk"

import { consoleLog } from "../utilities/helpers"

export async function fetchAddress(location) {
    try {
        consoleLog(`Fetching data from ${chalk.red(`Google Maps API`)}.`)
        const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location.coordinates.latitude},${location.coordinates.longitude}&key=${import.meta.env.VITE_GOOGLE_MAPS_API_KEY}`
        )
        const data = await response.json()
        // consoleLog("Google Maps API response:", data)
        if (data.results.length === 0) {
            return null
        }
        //TODO: Handle the case where the API returns an error
        return data.results[0]?.address_components
    } catch (error) {
        console.error("Error fetching country code:", error)
    }
}

export async function fetchCountry(addressComponents) {
    try {
        const countryComponent = addressComponents.find((component) =>
            component.types.includes("country")
        )
        return countryComponent ? countryComponent.long_name : null
    } catch (error) {
        console.error("Error fetching country:", error)
    }
}

export async function fetchCountryCode(addressComponents) {
    try {
        const countryComponent = addressComponents.find((component) =>
            component.types.includes("country")
        )
        return countryComponent ? countryComponent.short_name : null
    } catch (error) {
        console.error("Error fetching country code:", error)
    }
}

export async function fetchNeighborhood(addressComponents) {
    try {
        const localityComponent = addressComponents.find((component) =>
            component.types.includes("locality")
        )

        const regionComponent = addressComponents.find((component) =>
            component.types.includes("administrative_area_level_1")
        )

        const countryComponent = addressComponents.find((component) =>
            component.types.includes("country")
        )

        const neighborhood = [
            localityComponent?.long_name,
            regionComponent?.long_name,
            countryComponent?.long_name,
        ].filter(Boolean)
        return neighborhood
    } catch (error) {
        console.error("Error fetching neighborhood:", error)
    }
}
